import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SharedService } from '../../../layouts/shared-service';
import { AnalysisDetails, AnalysisDetailsqPCR, Cq } from '../../../model/analysis-details.model';
import { DropDownService } from '../../../service/drop-down.service';
import { UploadService } from '../../../service/upload.service';
import { StorageService } from '../../../service/storage.service';


@Component({
  selector: 'app-qpcr-report',
  templateUrl: './qpcr-report.component.html',
  styleUrls: ['./qpcr-report.component.scss']
})
export class QpcrReportComponent implements OnChanges, OnInit {

  @Input() analysistype?: string;
  @Input() editvalues: any;
  @Output() formvalue = new EventEmitter<any>();
  pageTitle = 'Analyze Report/Data';

  analysisFormGroup?: FormGroup;
  maxDate: any;
  analysisDetails?: AnalysisDetails;
  post: any;
  disabledValue: any;
  Cq = false;
  BackCalculated = false;
  decimalNumberPattern = '^(\\d{1,20})(\\.\\d{1,3})?$';
  percentfieldPattern = '^(100(\\.0{1,2})?|\\d{1,2}(\\.\\d{1,2})?)$';
  submitDisabled = true;

  constructor(
    private formBuilder: FormBuilder,
    private _sharedService: SharedService,
    private uploadService: UploadService,
    private dropDownService: DropDownService,
    private ref: ChangeDetectorRef,
    private storageService: StorageService
  ) {
    this._sharedService.emitChange(this.pageTitle);
    this.uploadService.disabledValue.subscribe(res => {
      this.disabledValue = res;

    });

  }

  ngOnInit(): void {
    this.createForm();
    this.analysisFormGroup?.valueChanges.subscribe(() => {
      this.updateButtonState();  // Update the submit button state
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('analysistype' in changes) {
      if (changes.analysistype.currentValue) {
        this.analysistype = changes.analysistype.currentValue;
      }
    }
  }


  createForm() {
    this.analysisFormGroup = this.formBuilder.group({
      analysisType: [this.analysistype],
      study: [null],
      multipleAnalytes: ['False'],
      TargetNames: this.formBuilder.array([]),
      files: [null],
      file_path: [null],
      projectCode: ['', [Validators.pattern('^[A-Za-z0-9 .,\\-_\']+$'), Validators.maxLength(150)]],
    });

    this.ref.detectChanges();


    if (this.editvalues !== undefined) {
      const qPCRvalue: AnalysisDetailsqPCR = new AnalysisDetailsqPCR();
      qPCRvalue.analysisType = this.analysistype;
      qPCRvalue.study = this.editvalues.study,
        qPCRvalue.projectCode = this.editvalues.projectCode;
      qPCRvalue.multipleAnalytes = this.editvalues.multipleAnalytes;
      qPCRvalue.TargetNames = this.editvalues.TargetNames;
      qPCRvalue.file_path = this.editvalues.file_path;
      qPCRvalue.files = this.editvalues.files;
      if (qPCRvalue.TargetNames && qPCRvalue.TargetNames.length > 0) {
        for (let i = 0; i < qPCRvalue.TargetNames.length; i++) {
          this.TargetNames.push(this.addAnalyteRows());
          this.setupTargetTypeListeners();
        }
      }

      this.analysisFormGroup.patchValue(qPCRvalue);
      this.updateButtonState();
    }

  }

  trackByIndex(index: number): number {
    return index;
  }

  atLeastOneCheckboxSelected(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const group = control as FormGroup;

      if (group.get('TargetType')?.value === 'QT') {
        const cq = group.get('QT.displayCq')?.value;
        const backCalculated = group.get('QT.displayBackCalculated')?.value;

        if ((!cq || cq === null) && (!backCalculated || backCalculated === null)) {
          return { atLeastOneCheckboxRequired: true };
        }
      }

      return null;
    };
  }


  updateValidity(controlIndex: number) {
    const targetControl = this.analysisFormGroup?.get(`TargetNames.${controlIndex}`); // Access by index
    if (targetControl) {
      const displayCqControl = targetControl.get('QT.displayCq'); // Assuming nested under QT
      const intraPrecControl = targetControl.get('QT.Cq.Intra_prec_CV_Cq');

      if (displayCqControl && displayCqControl.value === false && intraPrecControl) {
        intraPrecControl.reset();
        intraPrecControl.setErrors(null);
        intraPrecControl.markAsPristine();
        intraPrecControl.clearValidators();
        intraPrecControl.updateValueAndValidity();
      }
      else if (displayCqControl?.value == null && intraPrecControl?.value === null) {
        intraPrecControl.setErrors(null);
        intraPrecControl?.clearValidators();
        intraPrecControl?.updateValueAndValidity();
      }

      else if (displayCqControl?.value === false && intraPrecControl?.value === null) {
        intraPrecControl.setErrors(null);
        intraPrecControl?.updateValueAndValidity();
        this.analysisFormGroup?.updateValueAndValidity();
      }
      else if (displayCqControl?.value === true && intraPrecControl?.value === null) {
        targetControl.setValidators(this.atLeastOneCheckboxSelected());
        intraPrecControl.setValidators([Validators.pattern(this.percentfieldPattern), Validators.max(100)]);
      }

      intraPrecControl?.updateValueAndValidity();
      targetControl.updateValueAndValidity();


    }
  }

  updateValidityBackCalc(controlIndex: number) {
    const targetControl = this.analysisFormGroup?.get(`TargetNames.${controlIndex}`); // Access by index
    if (targetControl) {
      const displayBackCalcControl = targetControl.get('QT.displayBackCalculated');
      const genIntraPrecControl = targetControl.get('QT.BackCalculated.Gen_Intra_prec_CV_Back_Calc');
      const lloqUloqIntraPrecControl = targetControl.get('QT.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc');
      if (displayBackCalcControl && displayBackCalcControl?.value === false) {
        if (genIntraPrecControl) {
          genIntraPrecControl.reset();
          genIntraPrecControl.markAsPristine();
          genIntraPrecControl.clearValidators();
          genIntraPrecControl.updateValueAndValidity();
        }
        if (lloqUloqIntraPrecControl) {
          lloqUloqIntraPrecControl.reset();
          lloqUloqIntraPrecControl.markAsPristine();
          lloqUloqIntraPrecControl.clearValidators();
          lloqUloqIntraPrecControl.updateValueAndValidity();
        }
      }

      else if (displayBackCalcControl?.value === null && genIntraPrecControl?.value == null && lloqUloqIntraPrecControl?.value == null) {
        genIntraPrecControl?.reset();
        lloqUloqIntraPrecControl?.reset();
        genIntraPrecControl?.clearValidators();
        lloqUloqIntraPrecControl?.clearValidators();
        genIntraPrecControl?.updateValueAndValidity();
        lloqUloqIntraPrecControl?.updateValueAndValidity();
      }

      else if (displayBackCalcControl?.value === false && genIntraPrecControl?.value == null && lloqUloqIntraPrecControl?.value == null) {
        genIntraPrecControl?.reset();
        lloqUloqIntraPrecControl?.reset();
      }
      else if (displayBackCalcControl?.value === true && genIntraPrecControl?.value == null && lloqUloqIntraPrecControl?.value == null) {
        targetControl.setValidators(this.atLeastOneCheckboxSelected());
        genIntraPrecControl?.setValidators([Validators.pattern(this.percentfieldPattern), Validators.max(100)]);
        lloqUloqIntraPrecControl?.setValidators([Validators.pattern(this.percentfieldPattern), Validators.max(100)]);
      }
      genIntraPrecControl?.updateValueAndValidity();
      lloqUloqIntraPrecControl?.updateValueAndValidity();
      targetControl.updateValueAndValidity();
    }
  }


  get formControls() { return this.analysisFormGroup?.controls; }

  onSubmit(post: any) {
    this.analysisDetails = Object.assign({}, this.analysisFormGroup?.value);
    
   this.analysisDetails.TargetNames.forEach((target: any) => {
      if (target.TargetType == 'QT' && target.QT?.displayCq == null) {
        target.QT.displayCq = false;
      }
      else if (target.TargetType == 'QT' && target.QT?.displayBackCalculated == null) {
        target.QT.displayBackCalculated = false;
      }
    })
    this.analysisDetails!.userId = this.storageService.get('userId') ?? '';

    this.analysisDetails!.analysisId = (new Date).getTime().toString();
    this.analysisDetails!.targetName = this.TargetNames.value.map((res: any) =>
      res = res.targetName);
    this.post = post;
    this.formvalue.emit(this.analysisDetails);
  }

  isSubmitDisabled(): boolean {
    const targetNamesArray = this.analysisFormGroup?.get('TargetNames') as FormArray;
    if (targetNamesArray.length === 0) {
      return true;
    }
    const isInvalid = targetNamesArray.controls.some((target: AbstractControl) => {

      const targetType = target.get('TargetType')?.value;
      if (!targetType) {
        return true;
      }
      if (targetType === 'QT') {

        const QT = target.get('QT') as FormGroup;
        const displayCq = QT.get('displayCq')?.value;
        const displayBackCalculated = QT.get('displayBackCalculated')?.value;
        const isQTFieldsInvalid =
          !QT.get('QTRTsamples')?.value ||
          (QT.get('QTRTsamples')?.value === 'True' && !QT.get('contaminationThreshold')?.value) ||
          ((QT.get('QTRTsamples')?.value === 'False') && !QT.get('SpikeSamples')?.value) ||
          (QT.get('SpikeSamples')?.value === 'True' && (!QT.get('spikeCopies')?.value || !QT.get('recoveryThreshold')?.value)) ||
          ((QT.get('SpikeSamples')?.value === 'False') && !QT.get('InhibitionSamples')?.value) ||
          (QT.get('InhibitionSamples')?.value === 'True' && !QT.get('spikeCopies2')?.value) ||
          ((displayCq === false || displayCq === null) && (displayBackCalculated === false || displayBackCalculated === null)) ||
          (displayCq === true && !QT.get('Cq.Intra_prec_CV_Cq')?.value) ||
          (displayBackCalculated === true && (!QT.get('BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc')?.value && !QT.get('BackCalculated.Gen_Intra_prec_CV_Back_Calc')?.value));
        return isQTFieldsInvalid;
      }
      else if (targetType === 'QL') {
        const QL = target.get('QL') as FormGroup;
        const isQLFieldsInvalid =
          (QL.get('QLRTsamples')?.value === null) ||
          !QL.get('Intra_percent_CV')?.value || !!QL.get('Intra_percent_CV')?.errors || !QL.get('Threshold_CV')?.value || !!QL.get('Threshold_CV')?.errors;
        return isQLFieldsInvalid;
      }
      return false;
    });
    return isInvalid;
  }

  updateButtonState(): void {
    const isInvalid = this.isSubmitDisabled();
    const isFormValid = this.analysisFormGroup?.valid;
    this.submitDisabled = isInvalid || !isFormValid;
  }

  addAnalyteRows() {
    return this.formBuilder.group({
      targetName: ['', [Validators.pattern('^[A-Za-z0-9 .,\\-_\']+$'), Validators.maxLength(150)]],
      TargetType: [''],
      QL: this.formBuilder.group({
        QLRTsamples: [null],
        Intra_percent_CV: this.formBuilder.control(null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]),
        Threshold_CV: this.formBuilder.control(null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)])
      }),
      QT: this.formBuilder.group({
        QTRTsamples: [null],
        SpikeSamples: [null],
        InhibitionSamples: [null],
        contaminationThreshold: [null],
        recoveryThreshold: [null],
        spikeCopies: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
        spikeCopies2: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
        Gen_Inter_prec_CV_Back_Calc: [null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]],
        LLOQ_ULOQ_Inter_prec_CV_Back_Calc: [null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]],
        Gen_Intra_Inter_Acc_RE_Back_Calc: [null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]],
        ULOQ_LLOQ_Inter_Intra_RE_Back_Calc: [null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]],
        Lower_Slope_Value: this.formBuilder.control(null, [Validators.pattern('^[-]?(100(\\.0{1,20})?|\\d{1,2}(\\.\\d{1,20})?)$')]),
        Higher_Slope_Value: this.formBuilder.control(null, [Validators.pattern('^[-]?(100(\\.0{1,20})?|\\d{1,2}(\\.\\d{1,20})?)$')]),
        validators: [this.atLeastOneCheckboxSelected()],
        displayCq: [false],
        displayBackCalculated: [false],
        BackCalculated: this.formBuilder.group({
          Gen_Intra_prec_CV_Back_Calc: this.formBuilder.control(null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]),
          LLOQ_ULOQ_Intra_prec_CV_Back_Calc: this.formBuilder.control(null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]),
        }),
        Cq: this.formBuilder.group({
          Intra_prec_CV_Cq: this.formBuilder.control(null, [Validators.pattern(this.percentfieldPattern), Validators.max(100)]),
        }),
        QualityControls: this.formBuilder.group({
          LLOQ_QC: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
          Low_QC: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
          Mid_QC: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
          High_QC: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
          ULOQ_QC: this.formBuilder.control(null, [Validators.pattern(this.decimalNumberPattern)]),
        })
      })
    });

  }

  setupTargetTypeListeners(): void {
    const targets = this.analysisFormGroup?.get('TargetNames') as FormArray;

    targets.controls.forEach((control, index: number) => {
      const group = control as FormGroup;
      const targetTypeControl = group.get('TargetType');
      targetTypeControl?.valueChanges.subscribe((selectedType: string) => {
        const qtGroup = group.get('QT') as FormGroup;
        const qlGroup = group.get('QL') as FormGroup;

        if (selectedType === 'QT') {
          qtGroup.enable({ emitEvent: false });
          qlGroup.disable({ emitEvent: false });
          // Clear QL values and errors
          Object.keys(qlGroup.controls).forEach(controlName => {
            const control = qlGroup.get(controlName);
            control?.reset();
            control?.disable();
            control?.updateValueAndValidity();
          });
          this.applyValidators(qtGroup, this.addAnalyteRows());
          this.setupQtConditionalFields(index, qtGroup);
          this.updateValidity(index);
          this.updateValidityBackCalc(index);


        } else if (selectedType === 'QL') {
          qlGroup.enable({ emitEvent: false });
          qtGroup.disable({ emitEvent: false });

          Object.keys(qtGroup.controls).forEach(controlName => {
            const control = qtGroup.get(controlName);
            control?.reset();
            control?.disable();
            control?.updateValueAndValidity();
          });
          this.applyValidators(qlGroup, this.addAnalyteRows());
        } else {
          qtGroup.disable({ emitEvent: false });
          qlGroup.disable({ emitEvent: false });

          qtGroup.reset();
          qlGroup.reset();
        }
      });
    });
  }

  disableControl(control: AbstractControl<any, any> | null) {
    control?.disable();
    control?.reset();

  }

  private setupQtConditionalFields(index: number, qtGroup: FormGroup): void {
    const QTRTsamplesControl = qtGroup.get('QTRTsamples');
    const SpikeSamplesControl = qtGroup.get('SpikeSamples');
    const InhibitionSamplesControl = qtGroup.get('InhibitionSamples');
    const contThreshold = qtGroup.get('contaminationThreshold');
    const spikeCopies = qtGroup.get('spikeCopies');
    const recoveryThreshold = qtGroup.get('recoveryThreshold');
    const spikeCopies2 = qtGroup.get('spikeCopies2');


    QTRTsamplesControl?.valueChanges.subscribe((sampleValue: string) => {
      if (sampleValue === 'False' || sampleValue === null) {
        this.disableControl(contThreshold);
        SpikeSamplesControl?.enable();
        InhibitionSamplesControl?.enable();
      } else {
        contThreshold?.enable();
        this.disableControl(spikeCopies);
        this.disableControl(recoveryThreshold);
        this.disableControl(spikeCopies2);
        this.disableControl(SpikeSamplesControl);
        this.disableControl(InhibitionSamplesControl);
      }
    });

    SpikeSamplesControl?.valueChanges.subscribe((spikeValue: string) => {
      if (spikeValue === 'False' || spikeValue == null) {
        this.disableControl(spikeCopies);
        this.disableControl(recoveryThreshold);
        InhibitionSamplesControl?.enable();
      } else {
        spikeCopies?.enable();
        recoveryThreshold?.enable();
        this.disableControl(spikeCopies2);
        this.disableControl(InhibitionSamplesControl);

      }
    });

    InhibitionSamplesControl?.valueChanges.subscribe((inhibitionValue: string) => {
      if (inhibitionValue === 'False' || inhibitionValue === null) {
        this.disableControl(spikeCopies2);
      } else {
        spikeCopies2?.enable();
      }
    });

  }

  applyValidators(group: FormGroup, config: any): void {
    Object.keys(config).forEach(key => {
      const controlOrNested = config[key];
      const control = group.get(key);

      if (control instanceof FormControl) {
        control.setValidators(controlOrNested);
        control.updateValueAndValidity();
      } else if (control instanceof FormGroup && typeof controlOrNested === 'object') {
        this.applyValidators(control, controlOrNested); // recursive call for nested groups
      }
    });
  }


  getDropDownValues(key: string) {
    return this.dropDownService.dropDownsMap.get(key);
  }

  get TargetNames() {
    return this.analysisFormGroup?.get('TargetNames') as FormArray;
  }

  addAnalyte() {
    const targetArray = this.analysisFormGroup?.get('TargetNames') as FormArray;
    targetArray.push(this.addAnalyteRows());
    this.setupTargetTypeListeners();

  }

  removeAnalyte(index: number) {
    this.TargetNames.removeAt(index);
  }



}
